import { render, staticRenderFns } from "./Descprition3.vue?vue&type=template&id=c2474f0a&"
import script from "./Descprition3.vue?vue&type=script&lang=js&"
export * from "./Descprition3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports